import { defineMessages } from "@edx/frontend-platform/i18n";

const messages = defineMessages({
  latestAnnouncement: {
    id: "notification.sidebar.latestAnnouncement",
    defaultMessage: "Latest Announcement",
    description: "Title for the latest course announcement in the notification sidebar",
  },
  showMore: {
    id: "notification.sidebar.showMore",
    defaultMessage: "Show more",
    description: "Button text to expand the announcement",
  },
  showLess: {
    id: "notification.sidebar.showLess",
    defaultMessage: "Show less",
    description: "Button text to collapse the announcement",
  },
});

export default messages;

